// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"39ff3be9dcab87c9","570":"9974e21d9efc783b"}[chunkId] + ".js";
};